import { Component} from '@angular/core';

@Component({
  selector: 'error',
  templateUrl: './app-support.component.html',
  styleUrls: ['../shared/scss/app-error.component.scss']
})
export class AppSupportComponent {
}
